@if (sheet_ready) {
  <stream-sheet-view [process]="process" [processes]="flowSheet.processes"
  [streams]="flowSheet.streams"></stream-sheet-view>
}
